import { combineReducers } from "redux";
// web
import appReducer from "./appReducer";
import apiReducer from "./apiReducer";
const Reducers = combineReducers({
    appReducer,
    apiReducer
});
export default Reducers;
